// ACTIONS
export const SET_MODAL_VISIBLE = '[Offers] set modal visible';
export const setModalVisible = (payload) => ({ type: SET_MODAL_VISIBLE, payload });

// REDUCER
const INITIAL_STATE = {
  modalVisible: false,
  modalContent: {},
};

export default function ModalReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
  case SET_MODAL_VISIBLE:
    return {
      ...state,
      modalVisible: action.payload.visible,
      modalContent: action.payload.content,
    };

  default:
    return state;
  }
}
